import { render } from "./employee-leads-modal.vue?vue&type=template&id=60235172&scoped=true"
import script from "./employee-leads-modal.vue?vue&type=script&lang=js"
export * from "./employee-leads-modal.vue?vue&type=script&lang=js"

import "./employee-leads-modal.vue?vue&type=style&index=0&id=60235172&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60235172"]])

export default __exports__